import { LocalWorkspaceKernel, validateManifest, type LocalAppSession } from "./kernel";
import type { LocalAppManifest } from "./contracts";

export type LocalAppModule = {
  readonly manifest: LocalAppManifest;
  register(kernel: LocalWorkspaceKernel): LocalAppSession;
};

export function defineLocalApp(manifest: LocalAppManifest): LocalAppModule {
  validateManifest(manifest);
  const frozenManifest = structuredClone(manifest);
  return {
    manifest: frozenManifest,
    register(kernel: LocalWorkspaceKernel): LocalAppSession {
      kernel.register(frozenManifest);
      return kernel.openApp(frozenManifest.id);
    },
  };
}
